export type MiniAppTheme = 'light' | 'dark';

export function telegramChromeColor(theme: MiniAppTheme): string {
    return theme === 'dark' ? '#0d151f' : '#f4f5f7';
}

export function normalizeTheme(value: unknown): MiniAppTheme | null {
    return value === 'light' || value === 'dark' ? value : null;
}

export function resolveTheme(
    saved: unknown,
    telegramTheme?: unknown,
): MiniAppTheme {
    return normalizeTheme(saved) ?? normalizeTheme(telegramTheme) ?? 'dark';
}

export function readTheme(telegramTheme?: unknown): MiniAppTheme {
    try {
        return resolveTheme(
            window.localStorage?.getItem('miniapp-theme') ?? null,
            telegramTheme,
        );
    } catch {
        return resolveTheme(null, telegramTheme);
    }
}

export function applyAccountTheme(
    value: unknown,
    telegramTheme?: unknown,
): MiniAppTheme {
    const accountTheme = normalizeTheme(value);

    if (accountTheme) {
        persistTheme(accountTheme);

        return accountTheme;
    }

    clearStoredTheme();

    return resolveTheme(null, telegramTheme);
}

export function persistTheme(value: MiniAppTheme): void {
    try {
        window.localStorage?.setItem('miniapp-theme', value);
    } catch {
        // The account preference still persists through the API.
    }
}

function clearStoredTheme(): void {
    try {
        window.localStorage?.removeItem('miniapp-theme');
    } catch {
        // The Telegram preference still applies for the current session.
    }
}
